import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

export enum DocumentType {
  CONTACT = 'CONTACT',
  LOCATION = 'LOCATION',
  USER = 'USER',
  OPPORTUNITY = 'OPPORTUNITY',
  BILLING = 'BILLING',
  NOTE = 'NOTE',
  LOCATION_NOTE = 'LOCATION_NOTE',
  LOCATION_TASK = 'LOCATION_TASK',
  TASK = 'TASK',
  CUSTOM_VALUE = 'CUSTOM_VALUE',
  TAG = 'TAG',
  CALENDAR_EVENT = 'CALENDAR_EVENT',
  LC_COMMUNICATION = 'LC_COMMUNICATION',
  WORDPRESS = 'WORDPRESS',
  AGENCY = 'AGENCY',
  CUSTOM_FIELD = 'CUSTOM_FIELD',
  COMPANY = 'COMPANY',
  SAAS = 'SAAS',
  STRIPE = 'STRIPE',
  CONVERSATIONS = 'CONVERSATIONS',
  API_KEY = 'API_KEY',
}

export enum ActionType {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  DELETED = 'DELETED',
  RESTORED = 'RESTORED',
  MERGE_UPDATED = 'MERGE_UPDATED',
  MERGE_DELETED = 'MERGE_DELETED',
  TAG_ADDED = 'TAG_ADDED',
  TAG_REMOVED = 'TAG_REMOVED',
  COPIED = 'COPIED',
}

export enum Channel {
  APP = 'APP',
  OAUTH = 'OAUTH',
  INTERNAL_API = 'INTERNAL_API',
  DEV = 'DEV',
  EMPLOYEE_PORTAL = 'EMPLOYEE_PORTAL',
}

export enum AppSources {
  WEB_USER = 'WEB_USER',
  MOBILE_USER = 'MOBILE_USER',
  INTEGRATION_WEB_USER = 'INTEGRATION_WEB_USER',
}

export enum OAuthApiSources {
  INTEGRATION = 'INTEGRATION',
}

export enum InternalApiSources {
  BULK_ACTION = 'BULK_ACTION',
  BULK_REQUEST = 'BULK_REQUEST',
  CALENDAR = 'CALENDAR',
  CAMPAIGN = 'CAMPAIGN',
  FORM = 'FORM',
  FUNNEL = 'FUNNEL',
  INTEGRATION = 'INTEGRATION',
  MEMBERSHIP = 'MEMBERSHIP',
  PUBLIC_API = 'PUBLIC_API',
  SAAS = 'SAAS',
  SURVEY = 'SURVEY',
  TRIGGER = 'TRIGGER',
  WORKFLOW = 'WORKFLOW',
  EMAIL_BUILDER = 'EMAIL_BUILDER',
}

export interface AuditMeta {
  mergedWith: string[]
}
export interface IAuditLog {
  // Document Fields
  after?: object
  before?: object
  changedFields?: string[]
  documentType: DocumentType
  id: string // firestore doc id
  documentName?: string
  externalChange: boolean
  shardId: string
  type: ActionType
  forceRestore?:boolean
  secondaryId?:string

   // Extra info
   meta?: AuditMeta

  // Tracking Fields
  apiVersion?: string
  channel: Channel
  source: AppSources | OAuthApiSources | InternalApiSources
  sourceId: string
  sourceName?: string,
  subSource?: string
  sourceTraceId?: string
  traceId?: string
  createdAt?: string
  _id: string
  _v: number
}

export type AuditQuery = {
  companyId?: string
  locationId?: string,
  limit?: number
  documentType?: DocumentType
  startAt?: string,
  endAt?: string,
  userId?: string,
  sourceId?: string,
  secondaryId?: string,
  type?: ActionType,
  documentId?: string,
  paginateAt?: string,
  paginateType?: 'first' | 'after' | 'previous',
  ignoreWhiteList?: boolean,
  includeInternal?: boolean
}

// Configure request setup
const serviceName = 'AuditService'
const host = servicesConfig.Audit
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const AuditService = {
  search: (query: AuditQuery) =>
    request().get('/search', {
      params: {
        companyId: query.companyId,
        locationId: query.locationId,
        documentType: query.documentType,
        limit: query.limit || 8,
        type: query.type,
        id: query.documentId,
        paginateAt: query.paginateAt,
        paginateType: query.paginateType || 'first',
        userId: query.userId,
        sourceId: query.sourceId,
        secondaryId: query.secondaryId,
        startAt: query.startAt,
        endAt: query.endAt,
        // ignoreWhiteList: query.ignoreWhiteList,
        includeInternal: query.includeInternal
      },
    }).then(responseBody),
    
  addAuditLog: (body: any): Promise<any> => 
    request().post('/', body).then(responseBody)
}

export default AuditService
